import styled from 'styled-components';
import { FlexSpacer } from 'ui/flexSpacer';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

const SkeletonContainer = styled.div`
  padding-bottom: ${spacing.plusHalf};
`;

export const CampaignsHealthMetricsSkeleton = () => {
  return (
    <SkeletonContainer>
      <FlexSpacer flexDirection="column" alignItems="flex-start" gap={spacing.plusHalf}>
        <FlexSpacer gap={spacing.half} flexDirection="column" alignItems="flex-start">
          <Skeleton width={100} height={20} isRound isLoading />
          <FlexSpacer>
            <Skeleton width={100} height={40} isRound isLoading />
            <Skeleton width={100} height={16} isRound isLoading />
          </FlexSpacer>
        </FlexSpacer>

        <Skeleton width={'100%'} height={326} isLoading />
      </FlexSpacer>
    </SkeletonContainer>
  );
};
